export const whatsAppNumberApp = "+919539800051"
export const phoneNumberApp = "+919539800051"
export const emailApp = "mayavicakes@gmail.com"
export const locationIndia = ""
export const facebookLink = "https://www.facebook.com/mayavicakes"
export const twitterLink = "https://twitter.com/mayavicakes"
export const instagramLink = "https://www.instagram.com/mayavicakes"
export const linkedinLink = "https://www.linkedin.com/company/mayavicakes"
export const pinterestLink = "https://www.pinterest.com/mayavicakes"